/**
 * 组织架构页面路径
 */
export const ORGANIZATION_PAGE_PATH = '/organization'
